import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule, TranslateRegistry } from '@itonics/ngx-translate-simple';
import { LoaderComponent } from './component/loader.component';
import { de } from './i18n/de';
import { en } from './i18n/en';

@NgModule({
  declarations: [LoaderComponent],
  imports: [CommonModule, TranslateModule],
  exports: [LoaderComponent]
})
export class LoaderModule {
  constructor(private translateRegistry: TranslateRegistry) {
    this.translateRegistry.registerLoader((lang) => Promise.resolve({ en, de }[lang] || en));
  }
}
